import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IUntappdExternalUserResult } from '../../models/untappdExternal';
import { IUntappdSearchResultBeer } from '../../models/untappdExternal';
import { getFunctions, httpsCallable } from '@angular/fire/functions';
import { getApp } from '@angular/fire/app';
import { regionConst } from '../dal/databaseConstants';
import { IUntappdBeerResponse } from 'app/models/untappdExternalItem';


@Injectable({
  providedIn: 'root'
})
export class UntappdExternalService {

  constructor(private http: HttpClient) {
    if (!environment.production) {
      //angularFireFunctions.functions.useFunctionsEmulator('http://localhost:5001');
    }
  }



  authorize(untappdCode: string): Promise<any> {

    const functions = getFunctions(getApp(), regionConst.europeWest1);

    const callable = httpsCallable(functions, 'getUntappdAuthTokenRequest');
    const data$ = callable({
      redirectUrl: environment.untappd.redirectUrl,
      code: untappdCode
    });

    return data$;
  }


  selectUserInfo(token: string): Observable<IUntappdExternalUserResult> {
    return this.getUntappdInfo(token, 'user/info');
  }

  getBeerInfo(token: string, id: number): Observable<IUntappdBeerResponse> {
    return this.getByRoute(`https://api.untappd.com/v4/beer/info/${id}?access_token=${token}`);
  }

  search(token: string, query: string): Observable<IUntappdSearchResultBeer> {
    return this.getByRoute(`https://api.untappd.com/v4/search/beer?access_token=${token}&q=${query}`);
  }


  private getUntappdInfo<T>(token: string, method: string): Observable<T> {
    const route = `https://api.untappd.com/v4/${method}?access_token=${token}`;
    return this.getByRoute(route);
  }


  private getByRoute<T>(route: string): Observable<T> {
    return this.http.get<T>(route);
  }

}
